import { I16DIMADOUCISSEURPRIM_State } from '@batical/types/src'

const I16DIMADOUCISSEURPRIM: I16DIMADOUCISSEURPRIM_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_thEauVille: 0.0,
  in_thSouhaite: 0.0,
  in_volInst: 0.0,
  cpcTraitementLitreResine_uuid: '1',
  in_resineSouhaite: 0.0,
  in_debitHPointe: 0.0,
  res_cpcTraitementResine: 0.0,
  res_traitementPrevoir: 0.0,
  res_volAvantRegen: 0.0,
  res_consoSalt: 0.0,
  res_consoEauRenvoie: 0.0,
  res_tauxSodiumEau: 0.0,
  mode: 'none',
  res_diamAdouc: '',
  calcul_code: 'I16DIMADOUCISSEURPRIM'
}

export default I16DIMADOUCISSEURPRIM
